/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import DataTable from "./DataTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { qreq } from "../shared/qrequest";
import FormInput from "./FormInput";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Alert from "./Alert";
import Globals from "../shared/Globals";
import Auth from "../shared/Auth";
import ConfirmDialog from "./ConfirmDialog";
import Icon from "./Icon";
import { ImageGalleryOverlayGlobal } from "./ImageGalleryOverlay";

export default class DocumentList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            parentItem: props.parentItem ?? { id: 0 },
            parentVisit: props.parentVisit ?? { id: 0 },
            list: props.list,
            categories: [],
            showModal: false,
            uploadItem: {},
            uploading: false,
            edit: props.edit ?? false,
            editItem: {},
            showEditModal: false,
            showUploadButton: props.showUploadButton ?? true
        }
        this.key = props.key ?? '0';
        if (props.uploadFunc)
            this.upload = props.uploadFunc;
        else
            this.upload = this.upload.bind(this);
        this.onFileDrop = this.onFileDrop.bind(this);
        this.onFileDragOver = this.onFileDragOver.bind(this);
        this.onFileDragLeave = this.onFileDragLeave.bind(this);
        this.showDelete = this.showDelete.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/order/document-category/list', j => {
            if (j.list)
                this.setState({ categories: j.list });
            else if (j.errorCode !== 0)
                this.alert(j.errorMessage);
        }, () => {
            this.alert('Unknown error ocurred getting document categories.');
        });
        document.addEventListener('drop', this.onFileDrop);
        document.addEventListener('dragover', this.onFileDragOver);
        document.addEventListener('dragleave', this.onFileDragLeave);
    }

    componentWillUnmount() {
        document.removeEventListener('drop', this.onFileDrop);
        document.removeEventListener('dragover', this.onFileDragOver);
        document.removeEventListener('dragleave', this.onFileDragLeave);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.setState({ list: this.props.list });
        }
        if (prevProps.parentItem !== this.props.parentItem) {
            this.setState({ parentItem: this.props.parentItem });
        }
        if (prevProps.edit !== this.props.edit) {
            this.setState({ edit: this.props.edit });
        }
    }

    upload(e) {
        if (Auth.hasRole('readonly'))
            return;
        this.setState({ uploading: true });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            qreq.post('/api/order/document/upload', { orderID: this.state.parentItem.id, visitID: this.state.parentVisit.id, fileName: e.target.files[0].name, mimeType: e.target.files[0].type, dataSize: e.target.files[0].size, base64Content: b64data, documentCategoryID: this.state.uploadItem.documentCategoryID }, j => {
                if (j.errorCode === 0) {
                    this.state.list.push(j.item);
                    this.setState({ showModal: false, uploading: false, list: this.state.list });
                    this.props.onDocumentUpdate?.();
                }
                else {
                    this.alert(j.errorMessage);
                    this.setState({ uploading: false });
                }
                e.target.value = '';
            }, () => {
                this.alert('Unknown error ocurred. Please try again.');
                this.setState({ uploading: false });
                e.target.value = '';
            });
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }

    save(obj) {
        qreq.post('/api/document/save', obj, j => {
            if (j.errorCode === 0) {
                this.state.editItemRef.fileName = j.item.fileName;
                this.state.editItemRef.documentCategoryID = j.item.documentCategoryID;
                this.state.editItemRef.documentCategoryName = j.item.documentCategoryName;
                this.setState({ showEditModal: false, editItem: {} });
                this.props.onDocumentUpdate?.();
            }
            else
                this.alert(j.errorMessage);
        });
    }

    onFileDrop(e) {
        e.preventDefault();

        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.remove('active');
        });

        if (!this.state.edit)
            return;

        if (e.dataTransfer && e.dataTransfer.items) {
            [...e.dataTransfer.items].forEach(i => {
                if (i.kind === "file") {
                    const file = i.getAsFile();
                    this.upload({
                        target: {
                            files: [file],
                            value: ''
                        }
                    });
                }
            });
        }

        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.remove('active');
        });

    }

    onFileDragOver(e) {
        e.preventDefault();
        if (!this.state.edit)
            return;

        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.add('active');
        });
    }

    onFileDragLeave(e) {
        e.preventDefault();
        if (!this.state.edit)
            return;


        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        this.leaveTimeout = setTimeout(() => {
            document.querySelectorAll('.c-dropzone').forEach(i => {
                i.classList.remove('active');
            });
        }, 500);
    }

    showDelete(obj) {
        this.setState({ itemToDelete: obj, confirmMessage: 'Are you sure you want to delete \'' + obj.fileName + '\'?' });
    }

    delete(obj) {
        qreq.post('/api/document/delete', obj, j => {
            if (j.errorCode === 0) {
                this.state.list.splice(this.state.list.indexOf(obj), 1);
                this.setState({ list: this.state.list });
            }

        });
        this.setState({ confirmMessage: false });
    }

    showImageGallery = (item) => {
        item = { ...item };
        item.url = Globals.getImageURL(Globals.serverUrl + '/api/document/view/' + item.id);
        ImageGalleryOverlayGlobal.show([item]);
    }

    render() {
        if (!this.state.list)
            return null;
        return <>
            {this.state.showModal && <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title><L>Upload a Document</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormInput model={this.state.uploadItem} name="documentCategoryID" label="Document Type" type="select" options={this.state.categories} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ showModal: false })} disabled={this.state.uploading}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => { if (this.state.uploadItem.documentCategoryID) document.getElementById('c-documentlist-upload-' + this.key).click(); else this.alert('Please select a Document Type.'); }} disabled={this.state.uploading}>
                        <FontAwesomeIcon icon={fa.faUpload} /><L>Select File</L></Button>
                </Modal.Footer>
            </Modal>}
            {this.state.showEditModal && <Modal show={this.state.showEditModal} onHide={() => this.setState({ showEditModal: false })}>
                <Modal.Header closeButton>
                    <Modal.Title><L>Edit Document Category</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormInput model={this.state.editItem} name="fileName" label="File Name" type="text" required />
                    <FormInput model={this.state.editItem} name="documentCategoryID" label="Document Type" type="select" options={this.state.categories} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ showEditModal: false })} disabled={this.state.uploading}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => { if (this.state.editItem.documentCategoryID) this.save(this.state.editItem); else this.alert('Please select a Document Type.'); }} disabled={this.state.uploading}>
                        <FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></Button>
                </Modal.Footer>
            </Modal>}
            <ConfirmDialog show={this.state.confirmMessage} title="Confirm" message={this.state.confirmMessage} onConfirm={() => this.delete(this.state.itemToDelete)} onHide={() => this.setState({ confirmMessage: null })} />
            <Card title="Documents">
                <div className="d-none"><input type="file" id={'c-documentlist-upload-' + this.key} onChange={this.upload} /></div>
                {this.state.edit && this.state.showUploadButton && !Auth.hasRole('readonly') ?
                    <div className="btn-group py-3">
                        <button type="button" className="btn btn-primary" onClick={() => this.setState({ showModal: true })}><FontAwesomeIcon icon={fa.faUpload} /> Upload {this.state.list && this.state.list.length === 0 ? 'First' : 'Another'} Document</button>
                    </div> : ''}
                {this.state.edit && !Auth.hasRole('readonly') ?
                    <div className="c-dropzone m-3"><L>Drop files here...</L></div> : ''}
                {this.state.uploading ? <Alert message="Uploading...please wait..." icon="CloudArrowUp" /> : ''}
                <DataTable columns={[
                    { name: 'delete', title: '', onClick: obj => { this.showDelete(obj); }, valueFunc: obj => { if (obj.userID === Globals.get('user').id || Auth.hasRole('admin')) return <FontAwesomeIcon icon={fa.faTrash} />; else return ''; }, tooltip: 'Delete Document' },
                    {
                        name: 'fileName', title: 'Document', tooltip: 'View/Download Document', valueFunc: row => {
                            return <>
                                <a href={Globals.serverUrl + '/api/document/view/' + row.id} target="_blank" rel="noreferrer">{row.fileName}</a>
                                {!Auth.hasRole('readonly') && this.state.edit ? <span role="button" className="ms-1 text-primary" onClick={() => this.setState({ editItem: Globals.deepClone(row), editItemRef: row, showEditModal: true })}><Icon icon="faPencil" /></span> : null}
                                {row.mimeType.startsWith('image/') && <span role="button" onClick={() => this.showImageGallery(row)}><img src={Globals.getImageURL(Globals.serverUrl + '/api/document/view/' + row.id)} alt="" className="d-block img-fluid img-thumbnail" /></span>}
                            </>
                        }
                    },
                    { name: 'documentCategoryName', title: 'Type', onClick: this.state.edit ? obj => this.setState({ editItem: Globals.deepClone(obj), editItemRef: obj, showEditModal: true }) : null, tooltip: 'Edit Document Category' },
                    { name: 'userName', title: 'Uploaded By', className: 'd-none d-md-table-cell' },
                    { name: 'createdDate', title: 'Uploaded On', format: 'datetime', className: 'd-none d-md-table-cell' }
                ]} data={this.state.list} />
            </Card>
        </>
    }
}